<h3 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Session expiration</h3>
<div mat-dialog-content>
  <p>Your session will expire in {{ countDownDisplay }}.</p>
  <p>Press any key or move the mouse to stay logged in.</p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" aria-label="Ok" mat-dialog-close cdkFocusInitial tabindex="0">Ok</button>
</div>
